import { RootStoreState } from '@/store';
import { Module } from 'vuex';

export interface TrainingStoreState {
}

export default {
  state:{
  },
  mutations:{
  },
  actions:{
  },
  getters:{
  },
  namespaced: true,
}as Module<TrainingStoreState, RootStoreState>;
